import { Skeleton as SkeletonBase, ISkeletonProps } from './Skeleton';
import { Circle } from './Circle';
import { Rect } from './Rect';
import { FC } from 'react';

export interface INestedComponents {
  Rect: typeof Rect;
  Circle: typeof Circle;
}

export const Skeleton = SkeletonBase as FC<ISkeletonProps> & INestedComponents;

Skeleton.Rect = Rect;
Skeleton.Circle = Circle;
